import { render, staticRenderFns } from "./GroupScheduleEditor.vue?vue&type=template&id=3906115b&scoped=true"
import script from "./GroupScheduleEditor.vue?vue&type=script&lang=ts"
export * from "./GroupScheduleEditor.vue?vue&type=script&lang=ts"
import style0 from "./GroupScheduleEditor.vue?vue&type=style&index=0&id=3906115b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906115b",
  null
  
)

export default component.exports